import styled, { css } from 'styled-components';
import { Container } from '../../../ui/gridSystem';

export const Title = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};

  @media ${(props) => props.theme.device.tabletL} {
    font-size: 25px;
    text-align: center;
  }
`;

export const AnswerText = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  position: relative;
  width: 100%;
  background-color: ${(props) => props.theme.colors.bgPrimary};
  color: ${(props) => props.theme.colors.link};
  cursor: pointer;
  padding: 16px 30px 16px 24px;
  transition: ${(props) => props.theme.constants.transitionBase};
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    color: ${(props) => props.theme.colors.linkHover};
  }

  svg {
    stroke: ${(props) => props.theme.colors.link};
  }

  ${(props) =>
    props.isOpen &&
    css`
      color: ${props.theme.colors.focusSelect};
      &:hover {
        color: ${props.theme.colors.focusSelect};
      }
      svg {
        stroke: ${props.theme.colors.focusSelect};
      }
    `}
`;

export const AnswerBody = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  background-color: ${(props) => props.theme.colors.bgPrimary};
  color: ${(props) => props.theme.colors.textPrimary};
  position: relative;
  height: 0;
  transition: 0.3s all ease;
  padding: 0 30px 0 24px;

  @keyframes expand-answer {
    from {
      color: ${(props) => props.theme.colors.bgSecondary};
      height: 0%;
    }
    to {
      color: ${(props) => props.theme.colors.textPrimary};
      height: 100%;
    }
  }

  ${(props) =>
    props.isOpen &&
    css`
      padding: 8px 30px 40px 24px;
      height: 100%;
      animation: 400ms ease expand-answer forwards;
    `}
`;

export const AnswerContainer = styled.div`
  overflow: hidden;
  width: 100%;
  height: fit-content;
  border-top: 1px solid ${(props) => props.theme.colors.border};

  &:last-child {
    border-bottom: 1px solid ${(props) => props.theme.colors.border};
  }
`;

export const AnswersContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  ${AnswerContainer}:not(:last-child) {
    margin-bottom: 10px;
  }

  @media ${(props) => props.theme.device.tabletL} {
    border-left: none;
    padding-left: 0px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    max-width: 90%;
  }
`;

export const FaqContainer = styled(Container)`
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.transparent};
  padding-bottom: 64px;
`;

export const Section = styled.div`
  margin-top: 32px;
  border-bottom: 0.5px solid #646464;

  .title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
`;

export const QuestionsWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isOpen'].includes(prop),
})`
  position: relative;
  height: 0;
  transition: 0.3s all ease;
  padding: 0 30px 0 24px;
  overflow: hidden;

  ${(props) =>
    props.isOpen &&
    css`
      padding: 8px 30px 40px 24px;
      height: 100%;
      animation: 400ms ease expand-answer forwards;
    `}
`;
